import type { ApiType } from 'types/api_type';

export const contractsApi: Readonly<ApiType> = {
  path: '/contracts',
};

export const contractsApprovedFindPath = (): string => {
  return `${contractsApi.path}/approved`;
};

export const contractsPendingFindPath = (): string => {
  return `${contractsApi.path}/pending`;
};

export const contractsFindPath = (id: string): string => {
  return `${contractsApi.path}/${id}`;
};

export const contractsRequestCorrectionPath = (id: string): string => {
  return `${contractsApi.path}/${id}/request_correction`;
};

export const contractsApprovePath = (id: string): string => {
  return `${contractsApi.path}/${id}/approve`;
};

export const contractsDownloadPath = (id: string): string => {
  return `${contractsApi.path}/${id}/download`;
};
